;( function( $, window, document, undefined ) {
	"use strict";

	// Create the defaults once
	var pluginName = "masonryFilter",
		defaults = {
			propertyName: "value"
		};

	// The actual plugin constructor
	function Plugin ( element, options ) {
		this.element = element;
		this.instance = null;

		this.state = {
			stamped: false,
			filter: [],
			items: [],
			currentItem: null
		};

		this.settings = $.extend( {}, defaults, options );
		this._defaults = defaults;
		this._name = pluginName;
		this.init();
	}

	// Avoid Plugin.prototype conflicts
	$.extend( Plugin.prototype, {
		init: function() {
			this.state.items = $(this.element).find(this.settings.itemSelector);
			this.instance = this.initMasonry();

			$(this.element).on('click', '.Masonry-SingleItem-FullSize-Info-Switch', function (event) {
				$(this).siblings('.inner').slideToggle();
				$(this).toggleClass('Masonry-SingleItem-FullSize-Info-Switch_Closed');
				event.stopPropagation();
			});

			var me = this;
			$(this.element).on('click', this.settings.itemSelector, function (event) {
				me.changeFullScreenStamp($(this));
				event.stopPropagation();
			});

			$(this.element).on('click', '.Masonry-Stamp-FullScreen-Close', function (event) {
				me.closeFullScreenStamp($(this))
				event.stopPropagation();
			});

			$(this.element).imagesLoaded().progress(function () {
				me.instance.masonry('layout');
			});

			$(this.element).find('.GzlyCustomSelect').on('GzlyCustomSelect:change', function () {
				me.state.filter = [];

				$(me.element).find('.GzlyCustomSelect').each(function () {
					var data = [];
					var options = $(this).find('.GzlyCustomSelect--option');
					
					for (var i = 0; i < options.length; i++) {
						if (options[i].getAttribute('data-selected') === 'true') {
							data.push(options[i].getAttribute('data-value'));
						}
					}

					me.state.filter = me.state.filter.concat(data);
				});
				me.closeFullScreenStamp();
				me.filterMasonry();
			});

			var id = this.getIdByLocationHash();
			if (id !== '') {
				var item = $(me.settings.itemSelector + '[data-id='+ id +']');
				if (item.length > 0) {
					$(this.element).imagesLoaded(function () {
						me.changeFullScreenStamp(item);
					});
				}
			}
		},

		getIdByLocationHash: function () {
			return window.location.hash.replace('#!/', '');
		},

		closeFullScreenStamp: function () {
			window.location.hash = '!/';
			if (this.state.currentItem != null) {
				this.updateTransformOriginByItem(this.state.currentItem);
			}

			$('body').removeClass('Masonry_Stamped');
			$(this.element).removeClass('Masonry_Stamped');
			$(this.settings.itemSelector).removeClass('Masonry-SingleItem_Active');

			var me = this;

			if (this.state.currentItem != null) {
				me.scrollViewToElement(me.state.currentItem, true);
			}

			me.state.stamped = !me.state.stamped;
			me.state.currentItem = null;
		},

		changeFullScreenStamp: function (item) {
			item.addClass('Masonry-SingleItem_Visited');

			$(this.settings.itemSelector).removeClass('Masonry-SingleItem_Active');
			item.toggleClass('Masonry-SingleItem_Active');

			var fullScreenContent = $(item.find('.Masonry-FullScreenTemplate').html());
			var fullScreenWrapper = $(this.element).find('.Masonry-Stamp-FullScreen');

			var spacerElement = $(this.element).find('.Masonry-SingleItem_NormalForm');
			var left = spacerElement.width() + 2;
			var spacerHeight = spacerElement.height();

			var me = this;
			fullScreenContent.imagesLoaded(function () {
				var imgWidth = fullScreenContent.find('img')[0].width;
				var imgHeight = fullScreenContent.find('img')[0].height;
				
				imgWidth = $(window).width() - 200;
				imgHeight = $(window).height() - 200;

				
				if ($(window).width() > 768) {
					fullScreenWrapper.css({
						top: ($(window).height()) / 2 - (imgHeight / 2),
						left: ($(window).width() / 2) - (imgWidth / 2),
						height: imgHeight,
						width: imgWidth,
					});

					fullScreenWrapper.find('.Masonry-SingleItem-FullSize').css({
						top: '50%',
						transfrom: 'translateY(-50%)',
						height: fullScreenWrapper.find('.Masonry-SingleItem-FullSize img').height(),
					});
				}

				fullScreenWrapper.html('').append(fullScreenContent);


				fullScreenWrapper.css({
					'transform-origin': '50% 50%'
				});

				window.location.hash = '!/'+ item.data('id');
				me.state.currentItem = item;
				me.state.stamped = !me.state.stamped;
				me.scrollViewToElement($(me.settings.itemWrapperSelector));
				$(me.element).addClass('Masonry_Stamped');
				
				$('body.Masonry_Stamped').off('click')
				$('body').addClass('Masonry_Stamped');
				$('body.Masonry_Stamped').one('click', function (event) {
					me.closeFullScreenStamp($(this));
					event.stopPropagation();
				});
				fullScreenContent.on('click', 'img', function (event) {
					event.stopPropagation();
				});
			});
		},

		filterMasonry: function () {
			var me = this;

			if (me.state.filter.length <= 0) {
				me.state.items.show();
				me.instance.masonry('layout');
				return;
			}

			me.state.items.each(function () {
				var filterMatches = 0;
				for(var i = 0; i < me.state.filter.length; i++) {
					if($(this).data('categories').indexOf( me.state.filter[i] ) !== -1) {
						filterMatches++;
					}
				}

				if (filterMatches > 0) {
					$(this).show();
				} else {
					$(this).hide();
				}
			});

			me.instance.masonry('layout');
		},

		updateTransformOriginByItem: function(item) {
			var fullScreenWrapper = $(this.element).find('.Masonry-Stamp-FullScreen');

			var itemOriginX = (item.offset().left + item.width() / 2) - fullScreenWrapper.offset().left;
			var itemOriginY = (item.offset().top + item.height() / 2) - fullScreenWrapper.offset().top;

			var newOriginX = 100 / fullScreenWrapper.width() * itemOriginX;
			var newOriginY = 100 / fullScreenWrapper.height() * itemOriginY;

			fullScreenWrapper.css({
				'transform-origin': newOriginX +'% ' + newOriginY +'%'
			});
		},

		initMasonry: function() {
			return $( this.settings.itemWrapperSelector ).masonry({
				itemSelector: this.settings.itemSelector,
				columnWidth: '.Masonry-Item-Sizer',
				percentPosition: true
			});
		},

		getScrollOffset: function(el, viewMid) {
			var elOffset = el.offset().top;

			if (viewMid !== true) {
				return elOffset;
			}

			var offset;
			var elHeight = el.height();
			var windowHeight = $(window).height();

			if (elHeight < windowHeight) {
				offset = elOffset - ((windowHeight / 2) - (elHeight / 2));
			}
			else {
				offset = elOffset;
			}

			return offset;
		},

		scrollViewToElement: function(el, viewMid) {
			var offset = this.getScrollOffset(el, viewMid);
			this.scrollViewToOffset(offset);
		},

		scrollViewToOffset: function(offset) {
			var speed = 700;
			$('html, body').animate({scrollTop:offset}, speed);
		}

	} );
	$.fn[ pluginName ] = function( options ) {
		return this.each( function() {
			if ( !$.data( this, "plugin_" + pluginName ) ) {
				$.data( this, "plugin_" +
					pluginName, new Plugin( this, options ) );
			}
		} );
	};

} )( jQuery, window, document );